import VueSingleSelect from "vue-single-select";

import { VMoney } from 'v-money'
import { axiosRequest } from '../../utils/Requests.js';
import { getReais, getCentavos, getNumeroSemFormatacao } from '../../utils/Utils.js';

export default {
  components: { 
    VueSingleSelect
  },
  directives: { money: VMoney },
  props: [ 'id', 'imobiliaria'],
  data() {
    return {
      tabAtiva: 'alugar',
      cidadeBairro: undefined,
      keyValorMinimo: 0,
      keyValorMaximo: 0,
      valorMinimo: undefined,
      valorMaximo: undefined,

      params: {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: undefined,
        quartos: undefined,
        area: undefined
      },

      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },

      loadingImovel: true,
      imovel: {
        tipo: {}
      },

      urlMapaEstatico: null,
      urlPlace: null,
    }
  },
  computed: {
    tituloImovel() { return (this.imovel.tituloSite ? "#" + this.imovel.idNaImobiliaria + " - " + this.imovel.tituloSite : ""); },

    somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
    somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
    ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

    listaCidadesBairros() {
      let array = this.imobiliaria.cidades.map((cidade) => { return { nome: cidade.nome, id: cidade.id } })
      array = array.concat(this.imobiliaria.bairros.map((bairro) => { return { nome: bairro.nome + ' (' + bairro.cidade.nome + ')', id: bairro.cidade.id + "-" + bairro.id } }))
      return array
    },
    numeroWhatsApp() {
      if(this.imovel.operacao == "ALUGUEL") {
        if(this.imobiliaria.whatsappAluguel) { return this.imobiliaria.whatsappAluguel; }
        if(this.imobiliaria.whatsappVenda) { return this.imobiliaria.whatsappVenda; }
      } 
      
      if(this.imovel.operacao == "VENDA") {
        if(this.imobiliaria.whatsappVenda) { return this.imobiliaria.whatsappVenda; }
        if(this.imobiliaria.whatsappAluguel) { return this.imobiliaria.whatsappAluguel; }
      }

      return undefined;
    },
    numeroWhatsAppSemFormatacao() {
      if(this.imovel.operacao == "ALUGUEL") {
        if(this.imobiliaria.whatsappAluguelSemFormatacao) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        if(this.imobiliaria.whatsappVendaSemFormatacao) { return this.imobiliaria.whatsappVendaSemFormatacao; }
      } 
      
      if(this.imovel.operacao == "VENDA") {
        if(this.imobiliaria.whatsappVendaSemFormatacao) { return this.imobiliaria.whatsappVendaSemFormatacao; }
        if(this.imobiliaria.whatsappAluguelSemFormatacao) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
      }
    },

    constructWhatsAppLink() {
      const mensagem = encodeURIComponent(`Olá, tenho interesse no imóvel ${this.imovel.tituloSite} (cod. ${this.imovel.idNaImobiliaria}).`);
      const link = `https://wa.me/55${this.numeroWhatsAppSemFormatacao}?text=${mensagem}`;
      return link;
    },

    urlVideo() {
      if(!this.imovel.urlVideo) {
        return '';
      }

      const urlBase = 'http://www.youtube.com/embed/';
      const urlVideo = this.imovel.urlVideo;

      const pattern1regEx = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=.+$/;
      const pattern2regEx = /^(https?:\/\/)?(www\.)?youtu\.be\/.+$/;

      if(pattern1regEx.test(urlVideo)) {
        const params = urlVideo.split('watch?v=')[1];
        const idVideo = params.split('&')[0];
        return `${urlBase}${idVideo}`;
      }

      if(pattern2regEx.test(urlVideo)) {
        const params = urlVideo.split('youtu.be/')[1];
        const idVideo = params.split('&')[0];
        return `${urlBase}${idVideo}`;
      }

      return '';
    },

    isMapaVisible() {
      return this.urlMapaEstatico != null;
    },
  },
  watch: {
    'valorMinimo'(newValue, oldValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMinimo = undefined
        this.params.valorMinimo = undefined
        this.keyValorMinimo++
        this.$nextTick(() => this.$refs.valorMinimoInput.focus())
      } else {
        this.params.valorMinimo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    'valorMaximo'(newValue, oldValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMaximo = undefined
        this.params.valorMaximo = undefined
        this.keyValorMaximo++
        this.$nextTick(() => this.$refs.valorMaximoInput.focus())
      } else {
        this.params.valorMaximo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    cidadeBairro() {
      if(!this.cidadeBairro) {
        this.params.cidade = undefined
        this.params.bairro = undefined
        return
      }

      let array = this.cidadeBairro.id.toString().split("-")
      this.params.cidade = (array[0] ? array[0] : undefined)
      this.params.bairro = (array[1] ? array[1] : undefined)
    },
    imovel() {
      let titulo = this.imovel.tipo.nome + " para " + (this.imovel.operacao == "ALUGUEL" ? "alugar" : "vender") 
      titulo += " - " + this.imovel.bairro + ", " + this.imovel.cidade
      titulo +=   " | " + this.imobiliaria.nome
      
      document.title = titulo;
    }
  },
  created() {
    axiosRequest.get('/imovel/' + this.$route.params.id)
    .then((resultado) => {
        if(resultado.data.item.id !== 0) {
          this.setData(resultado.data.item)
          this.setUrlMapaEstatico(resultado.data.item.urlMapaEstatico);
          this.setUrlPlace(resultado.data.item.urlPlace);
        } else {
          this.$router.replace('/404');
        }
    }).catch((erro) => {
        console.log(erro)
    }).finally(() => {
      this.loadingImovel = false;
    });
  },
  mounted() {
    this.tabAtiva = (this.somenteVenda ? "comprar" : "alugar")
    this.params.operacao = (this.somenteVenda ? "COMPRA" : "ALUGUEL");
  },
  methods: {
    getReais,
    getCentavos,

    setData(imovel) {
        this.imovel = imovel
        this.loadingImovel = false
    },

    setUrlMapaEstatico(url) {
      this.urlMapaEstatico = url;
    },
    setUrlPlace(url) {
      this.urlPlace = url;
    },

    pesquisar() {
      this.params.operacao = (this.tabAtiva == "alugar" ? "ALUGUEL" : "VENDA")
      this.pagina = 0;

      this.$router.push(this.montarURL())
    },
    montarURL() {
      return {
        path: this.montarParametroURL(),
        query: { 
          pagina: this.pagina,
          valorMinimo: (this.params.valorMinimo ? this.params.valorMinimo : undefined),
          valorMaximo: (this.params.valorMaximo ? this.params.valorMaximo : undefined),
          quartos: (this.params.quartos ? this.params.quartos : undefined),
          area: (this.params.area ? this.params.area : undefined)
        }
      }
    },
    montarParametroURL() {
      var texto = "/imoveis/" + this.tabAtiva

      let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.id == this.params.tipoImovel })[0];
      if(tipo) { texto += "/" + tipo.key }

      let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.id == this.params.cidade })[0];
      if(cidade) { texto += "/" + cidade.key }

      let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.id == this.params.bairro })[0];
      if(bairro) { texto += "/" + bairro.key }

      return texto;
    }
  }
}
